export const categories = [
  { slug: "dianying", name: "电影", icon: "ri-movie-2-line", description: "经典国产电影，重温91年银幕记忆" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-line", description: "热门国产电视剧全集在线观看" },
  { slug: "zongyi", name: "综艺", icon: "ri-live-line", description: "热门国产综艺节目每日更新" },
  { slug: "dongman", name: "动漫", icon: "ri-rocket-line", description: "国产动漫精选合集" },
  { slug: "jilupian", name: "纪录片", icon: "ri-film-line", description: "珍贵国产纪录片资源" },
];

export const videos = [
  {
    id: 1,
    title: "大决战之辽沈战役",
    slug: "da-jue-zhan-liao-shen",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20war%20movie%20scene%20from%201991%2C%20dramatic%20battlefield%20with%20soldiers%2C%20cinematic%20lighting%2C%20warm%20retro%20film%20grain%20aesthetic%2C%20Chinese%20revolution%20era%20costumes%2C%20intense%20atmosphere%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    duration: "2小时18分",
    year: 1991,
    rating: 9.2,
    description: "1991年出品的重大革命历史题材电影，以恢弘的战争场面和细腻的人物刻画，再现了解放战争时期辽沈战役的壮阔历史画卷。影片由八一电影制片厂摄制，汇集了众多实力派演员，是中国战争电影的经典之作。",
    director: "李俊",
    cast: ["古月", "苏林", "赵恒多", "吴志远"],
    updateDate: "2026-07-28",
    views: 128560,
    tags: ["战争", "历史", "经典"],
  },
  {
    id: 2,
    title: "大红灯笼高高挂",
    slug: "da-hong-deng-long-gao-gao-gua",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Artistic%20Chinese%20film%20scene%20with%20red%20lanterns%20hanging%20in%20traditional%20courtyard%2C%20period%20drama%20aesthetic%2C%20rich%20warm%20colors%2C%20Chinese%20actress%20in%20traditional%20qipao%20dress%2C%20cinematic%20composition%2C%20dramatic%20shadows%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    duration: "2小时5分",
    year: 1991,
    rating: 8.8,
    description: "张艺谋导演的经典之作，改编自苏童小说《妻妾成群》。影片以民国时期为背景，通过一个女学生嫁入封建大家庭的遭遇，深刻揭示了中国传统封建礼教对人性的扭曲和摧残。影片在国内外获得多项大奖。",
    director: "张艺谋",
    cast: ["巩俐", "马精武", "何赛飞", "曹翠芬"],
    updateDate: "2026-07-25",
    views: 95630,
    tags: ["剧情", "经典", "文艺"],
  },
  {
    id: 3,
    title: "过年",
    slug: "guo-nian",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20family%20gathering%20during%20Spring%20Festival%20in%201990s%2C%20warm%20indoor%20scene%20with%20traditional%20decorations%2C%20family%20dinner%20table%2C%20nostalgic%20Chinese%20New%20Year%20atmosphere%2C%20film%20grain%20texture%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    duration: "1小时42分",
    year: 1991,
    rating: 9.0,
    description: "由黄建中执导的家庭伦理片，讲述了一个普通家庭在春节期间团聚的故事。影片通过家庭成员之间的情感纠葛和矛盾冲突，真实反映了改革开放初期中国社会的家庭关系变迁。",
    director: "黄建中",
    cast: ["李保田", "赵丽蓉", "六小龄童", "丁嘉丽"],
    updateDate: "2026-07-30",
    views: 78200,
    tags: ["家庭", "剧情", "经典"],
  },
  {
    id: 4,
    title: "编辑部的故事",
    slug: "bian-ji-bu-de-gu-shi",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=1990s%20Chinese%20office%20comedy%20TV%20series%20scene%2C%20vintage%20newsroom%20with%20typewriters%20and%20desks%2C%20Chinese%20actors%20in%20retro%20clothing%2C%20warm%20lighting%2C%20nostalgic%20Chinese%20television%20aesthetic%2C%20comedic%20expressions&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    duration: "25集",
    year: 1991,
    rating: 9.1,
    description: "中国第一部电视系列喜剧，以《人间指南》杂志编辑部为背景，通过编辑们的日常工作和生活，展现了九十年代初中国社会的方方面面。由葛优、吕丽萍等主演，至今仍被奉为中国情景喜剧的开山之作。",
    director: "赵宝刚",
    cast: ["葛优", "吕丽萍", "侯耀华", "张瞳"],
    updateDate: "2026-07-20",
    views: 156200,
    tags: ["喜剧", "经典", "都市"],
  },
  {
    id: 5,
    title: "外来妹",
    slug: "wai-lai-mei",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=1990s%20Chinese%20female%20factory%20workers%20in%20Guangdong%2C%20young%20women%20from%20countryside%20working%20in%20urban%20factory%2C%20retro%20Chinese%20TV%20drama%20aesthetic%2C%20warm%20documentary%20style%20lighting%2C%20nostalgic%20atmosphere&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    duration: "10集",
    year: 1991,
    rating: 8.7,
    description: "讲述了一群北方农村姑娘南下广东打工的故事，是中国第一部反映打工妹生活的电视剧。剧集真实记录了改革开放初期，大量农村劳动力涌入沿海城市的时代浪潮，引发了广泛的社会共鸣。",
    director: "成浩",
    cast: ["陈小艺", "汤镇宗", "李婷"],
    updateDate: "2026-07-18",
    views: 89200,
    tags: ["剧情", "现实", "都市"],
  },
  {
    id: 6,
    title: "上海一家人",
    slug: "shanghai-yi-jia-ren",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Vintage%20Shanghai%20family%20in%201990s%20apartment%2C%20traditional%20Chinese%20furniture%2C%20warm%20indoor%20lighting%2C%20multi%20generation%20family%20gathering%2C%20retro%20Chinese%20TV%20series%20aesthetic%2C%20nostalgic%20urban%20life%20scene&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    duration: "26集",
    year: 1991,
    rating: 8.9,
    description: "一部描绘上海普通市民家庭生活的电视剧，通过一个弄堂大家庭的喜怒哀乐，展现了上海从上世纪二十年代到改革开放时期的时代变迁。剧中塑造了众多鲜活生动的人物形象。",
    director: "李莉",
    cast: ["李羚", "谢园", "何伟"],
    updateDate: "2026-07-15",
    views: 104300,
    tags: ["家庭", "剧情", "年代"],
  },
  {
    id: 7,
    title: "综艺大观",
    slug: "zong-yi-da-guan",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=1990s%20Chinese%20variety%20show%20stage%20with%20colorful%20lights%20and%20decorations%2C%20Chinese%20hosts%20in%20elegant%20formal%20wear%2C%20live%20audience%2C%20retro%20television%20studio%20atmosphere%2C%20warm%20stage%20lighting%2C%20entertainment%20show%20aesthetic&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    duration: "全年合集",
    year: 1991,
    rating: 8.5,
    description: "央视经典综艺节目，汇集了歌舞、相声、小品、魔术等多种表演形式，是九十年代中国观众最喜爱的电视综艺节目之一。本合集收录了1991年全年的精彩节目内容。",
    director: "央视综艺频道",
    cast: ["倪萍", "赵忠祥", "杨澜"],
    updateDate: "2026-07-22",
    views: 67800,
    tags: ["综艺", "经典", "央视"],
  },
  {
    id: 8,
    title: "焦裕禄",
    slug: "jiao-yu-lu",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20biographical%20film%20scene%20from%201990s%2C%20dedicated%20official%20working%20in%20rural%20area%2C%20dusty%20landscape%2C%20Chinese%20countryside%2C%20warm%20cinematic%20lighting%2C%20inspirational%20atmosphere%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    duration: "1小时48分",
    year: 1990,
    rating: 9.3,
    description: "以真实人物焦裕禄为原型的传记电影，讲述了兰考县委书记焦裕禄带领群众治理风沙、盐碱和内涝的感人事迹。影片中李雪健的表演入木三分，将一位人民公仆的形象刻画得淋漓尽致。",
    director: "王冀邢",
    cast: ["李雪健", "李仁堂", "周宗印"],
    updateDate: "2026-07-27",
    views: 113400,
    tags: ["传记", "经典", "感人"],
  },
  {
    id: 9,
    title: "围城",
    slug: "wei-cheng",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20set%20in%201930s%2C%20elegant%20scholars%20in%20traditional%20Chinese%20clothing%2C%20vintage%20university%20setting%2C%20romantic%20literary%20atmosphere%2C%20warm%20nostalgic%20cinematography%2C%20TV%20series%20poster%20style&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    duration: "10集",
    year: 1990,
    rating: 9.4,
    description: "改编自钱钟书同名小说的经典电视剧，由陈道明、吕丽萍、英达等主演。剧集以抗战初期为背景，讲述了一群知识分子在爱情、婚姻和事业中的困境与抉择，被誉为中国电视剧史上不可超越的经典。",
    director: "黄蜀芹",
    cast: ["陈道明", "吕丽萍", "英达", "葛优"],
    updateDate: "2026-07-29",
    views: 189500,
    tags: ["经典", "剧情", "文学改编"],
  },
  {
    id: 10,
    title: "综艺大世界",
    slug: "zong-yi-da-shi-jie",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Colorful%20Chinese%20TV%20variety%20show%20stage%20with%20performers%2C%20bright%20stage%20lights%2C%20Chinese%20traditional%20and%20modern%20performances%2C%20live%20studio%20audience%2C%20entertainment%20program%20aesthetic%2C%20warm%20atmosphere&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    duration: "48期",
    year: 1991,
    rating: 8.3,
    description: "大型综艺娱乐节目，每期邀请当红明星和艺术家参与，包括歌曲演唱、才艺展示、游戏互动等环节。节目风格轻松活泼，是九十年代家庭娱乐的必备之选。",
    director: "央视文艺中心",
    cast: ["朱军", "周涛", "李咏"],
    updateDate: "2026-07-21",
    views: 54300,
    tags: ["综艺", "娱乐", "明星"],
  },
  {
    id: 11,
    title: "双旗镇刀客",
    slug: "shuang-qi-zhen-dao-ke",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20western%20film%20scene%20in%20desert%20town%2C%20lone%20swordsman%20silhouette%20against%20setting%20sun%2C%20dusty%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20Chinese%20wuxia%20movie%20aesthetic%2C%20dramatic%20composition&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    duration: "1小时31分",
    year: 1991,
    rating: 8.6,
    description: "何平导演的武侠西部片，被誉为中国武侠电影的里程碑之作。影片以西北大漠为背景，讲述了一个少年刀客在双旗镇与土匪对决的故事，风格粗犷豪放，充满东方武侠韵味。",
    director: "何平",
    cast: ["高伟", "赵玛娜", "常江"],
    updateDate: "2026-07-26",
    views: 72100,
    tags: ["武侠", "动作", "经典"],
  },
  {
    id: 12,
    title: "渴望",
    slug: "ke-wang",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=1990s%20Chinese%20emotional%20family%20drama%2C%20woman%20looking%20out%20window%20thoughtfully%2C%20warm%20domestic%20scene%2C%20retro%20Chinese%20apartment%20interior%2C%20soft%20lighting%2C%20nostalgic%20TV%20series%20aesthetic%2C%20emotional%20atmosphere&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    duration: "50集",
    year: 1990,
    rating: 9.0,
    description: "中国第一部大型室内剧，也是收视率最高的国产电视剧之一。以刘慧芳的命运为主线，讲述了几个家庭之间的恩怨情仇，引发了全国观众的强烈共鸣，播出时可谓万人空巷。",
    director: "鲁晓威",
    cast: ["张凯丽", "李雪健", "孙松", "黄梅莹"],
    updateDate: "2026-07-31",
    views: 223100,
    tags: ["家庭", "情感", "经典"],
  },
];

export const featuredVideos = [1, 4, 9, 2, 8, 12];

export const latestUpdates = [12, 1, 9, 3, 8, 7];

export const hotRecommendations = [2, 4, 6, 11, 5, 10];

export const aboutData = {
  brandName: "91视频",
  brandIntro: "91视频网站创建于2026年，是一家专注于国产影视内容聚合与传播的在线视频平台。我们致力于汇集和展示最优质的国产电影、电视剧、综艺节目等视频内容，为广大影视爱好者提供便捷、流畅的在线观看体验。",
  mission: "传承国产影视经典，让每一部好作品都被看见。我们相信，优秀的国产影视作品值得被更多人发现和欣赏。91视频以\"经典、品质、共享\"为核心理念，打造国产影视内容的一站式观看平台。",
  vision: "成为国内最具影响力的国产影视内容平台，让经典永流传，让好片不停歇。",
  teamIntro: "我们的团队由一群热爱影视文化的年轻人组成，涵盖内容运营、技术开发和用户体验等多个领域。团队成员来自国内顶尖互联网公司和影视机构，拥有丰富的行业经验和专业能力。",
  achievements: [
    { number: "500+", label: "影视资源" },
    { number: "50万+", label: "日活用户" },
    { number: "99.9%", label: "服务可用率" },
    { number: "4.8", label: "用户评分" },
  ],
  reviews: [
    { name: "张先生", role: "资深影迷", content: "91视频的资源太全了，很多以前找不到的老片子这里都有，画质也很清晰，推荐给所有喜欢国产老电影的朋友！" },
    { name: "李女士", role: "电视剧爱好者", content: "终于找到一个专注于国产内容的视频平台了，分类清晰，更新及时，每天都会上来看看有什么新内容。" },
    { name: "王同学", role: "影视专业学生", content: "作为影视专业的学生，91视频是我研究国产电影发展史的重要资源库，很多珍贵的91年影片都能在这里找到。" },
    { name: "赵女士", role: "家庭用户", content: "全家人都喜欢用91视频看国产剧，尤其是一些经典老剧，现在很难在其他平台看到了。感谢91视频的用心经营！" },
  ],
  contact: {
    email: "contact@91video.com",
    phone: "400-9100-091",
    address: "北京市朝阳区建国路91号国贸大厦B座",
    wechat: "91video_official",
    weibo: "@91视频官方",
  },
  faq: [
    { question: "91视频网站是否完全免费？", answer: "是的，91视频网站上的所有内容均为免费在线观看，无需付费或订阅会员即可畅享全部视频资源。" },
    { question: "如何搜索我想看的影片？", answer: "您可以在首页顶部的搜索框中输入影片名称、导演或演员姓名进行搜索，也可以通过分类页面按类别浏览您感兴趣的内容。" },
    { question: "视频画质如何？支持什么清晰度？", answer: "我们提供的视频均经过专业转码处理，支持高清画质播放，部分经典影片还提供修复版，画面更加清晰流畅。" },
    { question: "支持哪些设备观看？", answer: "91视频网站采用响应式设计，完美适配电脑、平板和手机等多种设备，随时随地畅享观影体验。" },
    { question: "视频内容多久更新一次？", answer: "我们每天都会更新新的视频内容，包括经典老片修复版、最新国产影视作品等，请关注首页的\"最新更新\"栏目。" },
    { question: "如何联系我们或提供建议？", answer: "您可以通过关于我们页面的联系方式与我们取得联系，包括邮箱、电话和社交媒体渠道，我们非常欢迎您的反馈和建议。" },
  ],
};

export const siteConfig = {
  name: "91视频",
  tagline: "91国产视频免费在线观看",
  description: "91视频网站国产影视专区，免费在线观看91国产视频、91年国产影片视频、国产电视剧全集、热门国产综艺，每日更新，高清流畅。",
  keywords: "91视频,91国产视频,91国产视频在线观看,91国产免费视频,91年国产影片视频,91国产电影,91国产电视剧,91国产综艺,91视频免费,91视频网站",
  url: "https://www.91video.com",
  ogImage: "https://readdy.ai/api/search-image?query=Chinese%20video%20streaming%20platform%20brand%20image%2C%20modern%20cinematic%20design%20with%20film%20reel%20elements%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20Chinese%20movie%20poster%20collage%20style%2C%20clean%20professional%20layout%2C%20entertainment%20media%20branding&width=1200&height=630&seq=og-image-91video&orientation=landscape",
};